import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageCountrySwitcherComponent } from './language-country-switcher.component';
import { ResponsiveModule } from '@viablelogic/ngx-responsive';

@NgModule({
    imports: [CommonModule, FormsModule, TranslateModule, LocalizeRouterModule, RouterModule, ResponsiveModule],
    declarations: [LanguageCountrySwitcherComponent],
    exports: [LanguageCountrySwitcherComponent]
})
export class LanguageCountrySwitcherModule {}
